import { carBrandcodes } from '../../constants';

export const footerDisclaimer = ({ termsOfUseUrl, fsgUrl }) => {
    return `<p>We recommend you read the Product Disclosure Statement (PDS) before you make a decision.</p>
    <p>Please note that when we display quotes on our comparison results page, they’re indicative only and subject to change based on further questions by the insurer.</p>
    <p>This webpage is hosted and managed by Compare the Market Pty Ltd ACN 117 323 378 AFSL 422926 (CTM) on behalf of Choosi Pty Ltd ABN 15 147 630 886; AFSL 402397 (Choosi).</p>
    <p>We don’t compare all car insurers or products in the market or all products offered by all brands.
     Information on this website is general and doesn’t take into account your personal objectives,
     financial situation, or needs. You should consider the relevant Product Disclosure Statement (PDS)
     for more information before deciding to purchase a product to ensure the product suits your needs.</p>
    <p>For more information about the range of insurers and products we compare, how our service works,
      and how we make our money (remembering that the service is free for you to use),
      read the <a target="_blank" href="${termsOfUseUrl}">Website Terms and Conditions</a> and <a href="${fsgUrl}" target="_blank">Financial Services Guide</a>.</p>
    <p>Vehicle information has been provided by <a id="redbookDisclosureOpen" data-id="redbookDisclosureOpen">Red Book</a>.</p> 
    <p>CTM is a related entity of Auto & General Services Pty Ltd, the issuer of some products available through CTM.</p>`;
};

export const trustedPartnerContent = () => {
    const trustedPartnerConfig = {
        title: 'Trusted Partners',
        description: 'Our Trusted Partners, for the purpose of your invitation to call, are:',
        reasons: [
            'the insurer that ranks in position 1 on the results page;',
            'any other insurer with whom you express an interest to contact, by commencing an online application or enquiry.'
        ],
        disclaimer: ''
    };
    return trustedPartnerConfig;
};


export const redbookDisclosureContent = () => {
    const redbookDisclosureConfig = {
        title: 'Vehicle Information Provided by Red Book',
        description: 'Vehicle information has been provided by Automotive Data Services Pty Ltd (Red Book). Red Book has prepared this '
            + 'data and valuations from information gathered from a variety of sources. Whilst all care has been taken in producing the '
            + 'data and valuations, Red Book cannot guarantee or make any representations regarding the use of, or reliance, on it. '
            + 'Red Book is not responsible for all the information provided to it and you should not rely on the data or valuations '
            + 'without making your own independent assessment for the vehicle and other sources of information. Red Book is not liable '
            + 'for any loss or damages (other than in respect of any liability which may not lawfully be excluded) relating to your use of, '
            + 'reliance on, this valuation and data.'
    };
    return redbookDisclosureConfig;
};

export const partnerBrands = () => [
    carBrandcodes.BUDD,
    // carBrandcodes.WOOL
    // carBrandcodes.VIRG
];

export const crossSellOtherVerticalsOnResults = () => false;
export const spinnerColour = () => '#FE5A19';
export const showNoResultsOverlayGenericMessage = () => true;
export const resultsScreenDefaultDisplayMode = () => 'row';

export const contactDetailOptInPrivacyMessage = ({ termsOfUseUrl, fsgUrl, privacyPolicyUrl }) => {
    return `I have received and accept the <a href="${termsOfUseUrl}" target="_blank" data-id="websiteTermsOfUseFooterLink">Website Terms of Use</a>,
    <a href="${fsgUrl}" target="_blank" data-id="financialServicesGuideLink">Financial Services Guide</a> and
    <a href="${privacyPolicyUrl}" target="_blank" data-id="websitePrivacyPolicyFormTermsLink">Privacy Policy</a>.
    By providing a contact number, I invite Choosi and/or its trusted partners to call me to discuss the potential purchase of a product
    and I agree that Choosi may email, SMS or otherwise contact me about all products and services it provides.`;
};

export const enableResultsFeatureAccordion = () => false;
export const showPriceConfidenceBanner = () => false;
export const spinnerType = () => 'Default';
